<template>
<div class="page_order page">
    <van-tabs v-model="active" swipe-threshold="6" @click="onTabsClick">
        <van-tab title="全部" :name="0"></van-tab>
        <van-tab title="待支付" :name="1"></van-tab>
        <van-tab title="待发货" :name="2"></van-tab>
        <van-tab title="待收货" :name="3"></van-tab>
        <van-tab title="待评价" :name="4"></van-tab>
        <!-- <van-tab title="售后" ></van-tab> -->
    </van-tabs>
    <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
    </van-list> -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list">
                <div class="item" v-for="order in orderList" :key="order.order_id">
                    <div class="item_t">
                        <div class="item_t_t">
                            <img :src="order.tradesman_thumb ? ($publicData.withHttpStart(order.tradesman_thumb) ? order.tradesman_thumb :imageUrl+order.tradesman_thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="title">{{ order.tradesman_name }}</div>
                        </div>
                        <div class="status">{{ order.statusTitle }}</div>
                    </div>
                    <div class="item_nr" v-for=" goods in order.order_good" :key="goods.title"  @click="goOrderDetail(order)">
                        <div :class="goods.is_blockchain ? 'item_nr_l blockchain' : 'item_nr_l'">
                            <img :src="goods.thumb ? imageUrl+goods.thumb : $publicData.intangibleDefault" alt="" class="tu">
                        </div>
                        <div class="item_nr_r">
                            <div class="item_nr_r_t">
                                <div class="title slh">{{ goods.title }}</div>
                                <div class="info">
                                    <span class="price"><span class="tag_cash">¥</span>{{ goods.price }}</span>
                                    <span class="nums">x{{ goods.num }}</span>
                                </div>
                            </div>
                            <div class="sku">{{ goods.spec_name }}</div>
                        </div>
                    </div>
                    <div class="item_b">
						<div class="sum" v-if="order.discount">折扣: <span class="sum_r">{{ order.dazhe }}</span></div>
                        <div class="sum">共{{ order.nums }}件商品<span class="sum_r">合计：¥ <span class="total_price">{{ order.total_prices }}</span></span></div>
                        <div class="actions">
                            <!-- <div class="action"  v-if="active==2" @click="sendOrder(order)">发货</div> -->
                            <!-- <div class="action"  v-if="active==1||active==2" @click="closeOrder(order)">关闭</div> -->
                            <!-- <div class="action"  v-if="active==5" @click="closeOrder(order)">退换货</div> -->
                            <!-- <div class="action" style="cursor: pointer" @click="goOrderDetail(order)">查看详情</div> -->
                            <!-- <div class="action"  v-if="order.pay_status==0" @click="toPay(order)">付款</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
    
</div>
</template>

<script>

import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 0,
            orderList: [],
            token: '',
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
            uuid:this.$route.query.uuid,//匠人uuid，语音播报使用
			sorce: this.$route.query.sorce, // 0商城1云支付
            is_platprice: this.$route.query.is_platprice, //0匠人 1供应商 2园区
        };
    },
    created: function () {
              
    },
    mounted: function () {
		if(localStorage.getItem('shopOrderStatus') != null){
			this.active = parseInt(localStorage.getItem('shopOrderStatus'))
		}else if(this.$route.query.status != null){
			this.active = parseInt(this.$route.query.status)
		}
        
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '订单列表',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {
                
            })
            //获取用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                }
            })
            // //启动播报监听
            // var voiceParams = {
            //     'data': {
            //         'roomid':this.uuid
            //     }
            // }
            // console.log('sdjy://public/orderSpeak')
            // this.$bridge.callhandler('sdjy://public/orderSpeak', voiceParams, (data) => {
            //     if (data.code == 200) {
                    
            //     }
            // })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.onRefresh()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.onRefresh();
        }
        
    },
    
    methods: {
        onTabsClick(name,title) {
            this.active = name
            this.onRefresh()
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                status: this.active,
                // sorce: this.sorce, // 不再区分云订单  2022年5月19日
                page: this.page,
                size: this.size
            }
            console.log('111111:'+this.is_platprice)
            if (this.is_platprice == null || this.is_platprice == undefined || this.is_platprice == '') {
                this.is_platprice = 0
            } 
            params.is_platprice = this.is_platprice
            this.$api.tradesman.order(params).then(res=>{
                if (res.code == 200) {
                    var list = res.result.list
                    for (let i = 0; i < list.length; i++) {
						var order = list[i];
						// 订单折扣
						var discount = order.discount
                        if (discount && discount!= 0) {
                            var discount = discount.toString()
                            var zhe = ''
                            if (discount.length == 1) {
                                zhe = discount /10 + '折'
                            } else if (discount.length > 1) {
                                if (discount[discount.length - 1] == 0) {
                                    zhe = discount / 10 + '折'
                                } else {
                                    zhe = discount + '折'
                                }
                            }
                            order.dazhe = zhe
                        }
						// 订单状态
                        if (order.order_status == 0) {
                            order.statusTitle = '已取消'
                        } else if (order.receipt_status == 1) {
                            // order.statusTitle = '已收货'
                            order.statusTitle = '交易成功'
                        } else {
                            if (order.ship_status == 1) {
                                // order.statusTitle = '已发货'
                                order.statusTitle = '等待收货'
                            } else {
                                if (order.pay_status == 0) {
                                    // order.statusTitle = '未支付'
                                    order.statusTitle = '等待付款'
                                } else if (order.pay_status == 1) {
                                    // order.statusTitle = '支付中'
                                    order.statusTitle = '等待付款'
                                } else if (order.pay_status == 2) {
                                    // order.statusTitle = '已支付'
                                    order.statusTitle = '等待发货'
                                }
                            }
                        }
                    }
                    if (this.page == 1) {
                        this.orderList = list
                    } else {
                        var old = this.orderList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.orderList = old
                    }
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                    // console.log('list', list)
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },
        // 订单详情
        goOrderDetail(order) {
            if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                var p = "?orderId="+order.order_id+'&role=1'+'&is_platprice='+this.is_platprice
                var params = {'data':{'url':this.$publicData.clientUrl+'/tradesman/orderDetail'+p}}
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/tradesman/orderDetail',
                    query:{
						orderId: order.order_id,
						role: 1,
                        is_platprice: this.is_platprice
                    }
                })
			}
			// 记录查询的哪一状态的订单，用于订单详情回退时获取状态
			localStorage.setItem('shopOrderStatus',this.active)
        },
        //发货
        sendOrder(order) {

        },
        closeOrder(order) {
            var params = {
                token: this.token,
                order_id: order.order_id,
            }
            this.$api.tradesman.closeOrder(params).then(res=>{
                if (res.code == 200) {
                    this.$toast('关闭订单成功')
                    this.onRefresh()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toPay(order) {
            if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                var p = "?orderId="+order.pay_order_num+'&price='+order.total_prices
                var params = {'data':{'url':this.$publicData.clientUrl+'/shop/pay'+p}}
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/pay',
                    query:{
                        orderId: order.pay_order_num,
                        price: order.total_prices
                    }
                })
            }    
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
